import { render, staticRenderFns } from "./sleepBreathes.vue?vue&type=template&id=2daba185&scoped=true&"
import script from "./sleepBreathes.vue?vue&type=script&lang=js&"
export * from "./sleepBreathes.vue?vue&type=script&lang=js&"
import style0 from "./sleepBreathes.vue?vue&type=style&index=0&id=2daba185&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2daba185",
  null
  
)

export default component.exports